export const RefreshIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="18"
    fill="none"
    viewBox="0 0 16 18"
    {...props}
  >
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="m8.492 4 1.667-1.667L8.492.666M7.508 14l-1.666 1.667 1.666 1.666"
    ></path>
    <path
      stroke="#23252A"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.25"
      d="M12.73 4.309a6.64 6.64 0 0 1 1.938 4.69 6.667 6.667 0 0 1-8.55 6.393M3.212 13.634a6.64 6.64 0 0 1-1.878-4.635 6.667 6.667 0 0 1 8.55-6.393"
    ></path>
  </svg>
);
